var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagRoundHu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.1666H57V34.8333H0V22.1666Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6667 7.91663H6.33333C4.65363 7.91663 3.04272 8.58389 1.85499 9.77162C0.66726 10.9593 0 12.5703 0 14.25L0 22.1666H57V14.25C57 12.5703 56.3327 10.9593 55.145 9.77162C53.9573 8.58389 52.3464 7.91663 50.6667 7.91663Z",
    fill: "#CD2A3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 49.0834H50.6667C52.3464 49.0834 53.9573 48.4161 55.145 47.2284C56.3327 46.0407 57 44.4297 57 42.75V34.8334H0V42.75C0 44.4297 0.66726 46.0407 1.85499 47.2284C3.04272 48.4161 4.65363 49.0834 6.33333 49.0834Z",
    fill: "#436F4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRoundHu);
export default __webpack_public_path__ + "static/media/flag_round_hu.6dcb41cca5147ff950ccd1b7133b1375.svg";
export { ForwardRef as ReactComponent };